export default __webpack_public_path__ + "static/media/notfound.8bd6dcd0.png";